module.exports = __webpack_public_path__ + "e586bdd853c0c04899816e19bb0a2c43.png";